
/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class LegacyViewControllersAPI
 * @hideconstructor
 * @classdesc API class that can be used to create and access legacy layoutController and widgetLoader
 */
define([], () => {
	class LegacyViewControllersAPI {
		/**
		 * @description Get the layoutController object
		 * @return {object} the layoutController
		 */
		getLayoutController() {}

		/**
		 * @description Get the widgetLoader object
		 * @return {object} the widgetLoader
		 */
		getWidgetLoader() {}

		/**
		 * @description Calls destroy on the layoutController and the widgetLoader
		 */
		destroy() {}
	}

	return LegacyViewControllersAPI;
});
